import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const ROOTS_PARAMS = [
  {
    kind: 'int',
    key: 'strands',
    label: 'Wurzelstränge',
    min: 4,
    max: 2000,
    step: 1,
    scale: 'log',
    default: 160,
    bulkRange: [30, 600],
    group: 'Wuchs',
  },
  {
    kind: 'int',
    key: 'depth',
    label: 'Verzweigungstiefe',
    min: 1,
    max: 12,
    step: 1,
    default: 6,
    bulkRange: [3, 9],
    group: 'Wuchs',
  },
  {
    kind: 'float',
    key: 'segmentLength',
    label: 'Segmentlänge',
    min: 2,
    max: 90,
    step: 0.5,
    default: 26,
    unit: 'px',
    bulkRange: [8, 50],
    group: 'Wuchs',
  },
  {
    kind: 'float',
    key: 'lengthRatio',
    label: 'Längenverhältnis',
    min: 0.3,
    max: 1,
    step: 0.01,
    default: 0.78,
    group: 'Wuchs',
  },
  {
    kind: 'float',
    key: 'angle',
    label: 'Verzweigungswinkel',
    min: 2,
    max: 90,
    step: 0.5,
    default: 24,
    unit: '°',
    group: 'Wuchs',
  },
  {
    kind: 'float',
    key: 'jitter',
    label: 'Winkelstreuung',
    min: 0,
    max: 90,
    step: 0.5,
    default: 22,
    unit: '°',
    group: 'Wuchs',
  },
  {
    kind: 'int',
    key: 'children',
    label: 'Kindwurzeln',
    min: 1,
    max: 4,
    step: 1,
    default: 2,
    group: 'Wuchs',
  },
  {
    kind: 'float',
    key: 'gravity',
    label: 'Richtungs-Bias',
    min: -1,
    max: 1,
    step: 0.01,
    default: 0.45,
    group: 'Wuchs',
    tooltip: 'Positiv zieht die Wurzeln nach unten, negativ nach oben.',
  },
  {
    kind: 'float',
    key: 'repel',
    label: 'Textabstossung',
    min: 0,
    max: 3,
    step: 0.01,
    default: 0.8,
    group: 'Wuchs',
    tooltip: 'Hält die Wurzeln von den Buchstaben weg; sie kreuzen den Text nie.',
  },

  {
    kind: 'float',
    key: 'baseWidth',
    label: 'Startdicke',
    min: 0.3,
    max: 24,
    step: 0.1,
    default: 3.4,
    unit: 'px',
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'taper',
    label: 'Verjüngung',
    min: 0.3,
    max: 1,
    step: 0.01,
    default: 0.72,
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 0.85,
    group: 'Darstellung',
  },

  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'depth',
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'depth', label: 'Nach Tiefe' },
      { value: 'distance', label: 'Nach Textdistanz' },
    ],
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'earth' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type RootsValues = SchemaValues<typeof ROOTS_PARAMS>;
